import React from "react";
import "../Styles/landingpage.css";
import section1image from "../assets/section1image.jpg";
import { FaMapMarker, FaWifi } from "react-icons/fa";
import section2image1 from "../assets/section2image1.jpg";

const LandingPage = () => {
  return (
    <div>
      {/* Section 1 */}
      <section className="section1">
        <div className="mainDiv1">
          <div className="section1Div1">
            <h2>
              LifeBox – <br />
              Technology <br />
              <span className="gradient-text">That  Saves Lives</span>
            </h2>
            <span className="longer-text">
              Real-Time Emergency Response & Vaccine Cold
              <br /> Chain Monitoring for Every Community.
              <br /> Connecting health workers, patients, and
              <br /> organizations with life-saving technology.
            </span>
            <p className="paragraph">
              <span>
                <FaMapMarker /> Emergency Hospital Locator
              </span>
              <span>
                <FaWifi /> Offline & Remote Access
              </span>
            </p>
          </div>
          <div className="section1Div2">
            <img src={section1image} alt="Logo" />
          </div>
        </div>
        <div className="mainDiv2">
          <a href="/#">Request a Demo</a>
          <a href="/#">See How It Works</a>
          <a href="/#">Partner with LifeBox</a>
        </div>
      </section>
      {/* Section 2 */}
      <section className="section2">
        <div className="div1">
          <h1>Two Powerful Solutions, One Mission</h1>
          <h5>
            LifeBox combines emergency response technology with vaccine
            monitoring systems to create a <br /> comprehensive healthcare
            platform for any environment.
          </h5>
        </div>
        <div className="div2">
          <div className="div2subdiv1">
            <div>
              <h3>Emergency Medical Response System (ERSA)</h3>
              <h5>Instantly locate hospitals and coordinate emergency care</h5>
            </div>
            <div className="section2image1">
              <img src={section2image1} alt="Logo" />
            </div>
            <div className="container">
              <div class="item">
                <FaMapMarker />
                <div className="item-text">
                  <h4>GPS Hospital Locator</h4>
                  <h5>
                    Find nearby hospitals with real-time <br /> data
                  </h5>
                </div>
              </div>
              <div class="item">2</div>
              <div class="item">3</div>
              <div class="item">4</div>
            </div>
          </div>
          <div className="div2subdiv2">2</div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
